import SearchForm from './src/index'

SearchForm.install = function (Vue) {
  Vue.component(SearchForm.name, SearchForm)
}

export default SearchForm
